import { FC, useEffect, useState } from 'react';

import { CloseOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Input, Popover, Tree, Typography } from 'antd';
import _ from 'lodash';

import { generateListKeys, getParentKey, prepareData } from '../../../../helpers/utils/reports';
import FilterItemSelected from '../../../../shared/common/components/reports/params/filter/FilterItemSelected';
import RefreshButton from '../../../../shared/common/components/reports/params/filter/RefreshButton';
import RequestButton from '../../../../shared/common/components/reports/params/filter/RequestButton';
import { data, updateFilters } from '../../../../shared/common/constants/filters';
import { useActions } from '../../../../shared/common/hooks/useActions';
import { useTypedSelector } from '../../../../shared/common/hooks/useTypedSelector';

interface IUniversalFilterProps {
    isCompare: boolean
    withSegment: boolean
    disabled?: boolean
    disableAttr?: boolean
    filtersFilter?: string[]
    initialExpandedKeys?:string[]
    withLabel?:boolean
    notParams?:boolean
    filterName?: string;
    visibleFilters?: any[];
    isYM?: boolean;
}

export const listKeys = generateListKeys(data)


const UniversalFilter: FC<IUniversalFilterProps> = ({
                                                        isCompare,
                                                        withSegment,
                                                        filtersFilter,
                                                        disableAttr = false,
                                                        withLabel = true,
                                                        notParams = false,
                                                        initialExpandedKeys = [],
                                                        filterName,
                                                        visibleFilters = null,
                                                        isYM = false
                                                    }) => {

    const { filters,filterParent } = useTypedSelector(
        (state) => isYM? state.filter.yandexMetric : state.filter
    );
    const { setMetaCompare,setFilterParent,setFilters,setCurrentSegment,setAllDataFetching,setCurrentFunnel, setMetaFilterUpdate, setAllBlocksFetching } = useActions();
    const [ expandedKeys, setExpandedKeys ] = useState<string[]>(initialExpandedKeys);
    const [ searchValue, setSearchValue ] = useState('');
    const [ autoExpandParent, setAutoExpandParent ] = useState(true);
    const [ treeData, setTreeData ] = useState<any>([]);
    const [ btnDisabled, setBtnDisabled ] = useState(true);
    const [ isPopoverVisible, setIsPopoverVisible ] = useState(false);

    useEffect(() => {
        let data_ = data
        if(location.pathname === '/users/ad-reports'){
            data_ = updateFilters()
        }
        const filteredData = filtersFilter
            ? data_.filter((item:any) => filtersFilter.includes(item.name))
            : data_;
        const _data = prepareData(filteredData, searchValue, filters, disableAttr,'','','','',[ '' ],'',filterParent,undefined,isYM);

        if (_data.length === 1) {
            setAutoExpandParent(true)
            setExpandedKeys([ "0-0" ])
        }

        setTreeData(_data);
    }, [ data, searchValue, filters, filters.length, isCompare,filterParent,location.pathname,filtersFilter ]);

    useEffect(() => {
        if (!searchValue) {
            let data_ = data
            if(location.pathname === '/users/ad-reports'){
                data_ = updateFilters()
            }
            setAutoExpandParent(false)
            const filteredData = filtersFilter
                ? data_.filter((item:any) => filtersFilter.includes(item.name))
                : data_;
            const _data = prepareData(filteredData, searchValue, filters, disableAttr,'','','','',[ '' ],'',filterParent,undefined,isYM);

            setTreeData(_data)
        }
    }, [ searchValue ]);

    useEffect(() => {
        if (!isCompare) {
            setMetaCompare({value:false})
        }
    }, [ isCompare ])



    const onExpand = (_expandedKeys: any) => {
        setExpandedKeys(_expandedKeys)
        setAutoExpandParent(false)
    }

    const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target

        if (value !== "") {
            const reg = new RegExp(value, "i")
            const _treeData = treeData

            let _expandedKeys: any = listKeys
                .map((item: any) => {
                    if (item.name.search(reg) > -1) {
                        return getParentKey(item.id, _treeData)
                    }

                    return null
                })
                .filter(
                    (item: any, i: number, self: any) => item && self.indexOf(item) === i
                )

            setExpandedKeys(_expandedKeys)
            setSearchValue(value)
            setAutoExpandParent(true)
        } else {
            setSearchValue("")
            setAutoExpandParent(false)
        }
    }
    const onClearFilters = () => {
        setCurrentSegment(null);
        setCurrentFunnel([]);
        setFilters(isYM ? {data: [], isYM} : []);
        setFilterParent([]);
        setBtnDisabled(true);
        setAllDataFetching({ value:true });
    };

    const handleUpdateDashboardData = () => {
        setAllBlocksFetching({ value: true });
        setAllDataFetching({ value: true });
        setTimeout(() => {
            setAllBlocksFetching({ value: false });
            setMetaFilterUpdate({ value: false }); 
        }, 2000);
      };

    return (
        <div className="params__filter">
            {(filters.length > 0 && !isYM) && <Button
                style={{ marginRight:5 }}
                onClick={() => onClearFilters()}
                icon={<CloseOutlined />}
                title="Очистить"
            />}
            <div
                style={{
                    display: 'contents',
                    marginLeft: withSegment ? 10 : 0,
                    height: 34,
                }}
            >
                {withLabel && <Typography.Text type="secondary">
                    {filterName ?? 'Условия фильтра'}:&nbsp;
                </Typography.Text>}
                {filters.length === 0
                    ? null
                    : (visibleFilters ?? filters).map((item: any, index: number) => {
                        if (item.type === 'datetimerange') {
                            if (!item.start && !item.end) {
                                return null
                            }
                        }

                        let prefix = "и"
                        let secondPrefix = null
                        const prevIndex = index === 0 ? 0 : index - 1

                        if (
                            item.id === filters[prevIndex].id
                        ) {
                            prefix = "или"
                        }

                        if (item.id.includes("not_")) {
                            secondPrefix = "не"
                        }

                        return (
                            <>
                                {index !== 0 && (
                                    <Typography.Text type="secondary">
                                        &nbsp;{prefix}&nbsp;
                                    </Typography.Text>
                                )}
                                {secondPrefix ? (
                                    <b style={{ fontWeight: 600, color: "#ff0000" }}>
                                        {secondPrefix}&nbsp;
                                    </b>
                                ) : (
                                    ""
                                )}
                                {
                                    <FilterItemSelected
                                        arrayIndex={index}
                                        id={item.id}
                                        itemData={item}
                                        full_name={item.full_name}
                                        {...item}
                                        isYM={isYM}
                                    />
                                }
                            </>
                        )
                    })}
                &nbsp;
                <Popover
                    content={
                        <Tree.DirectoryTree
                            blockNode
                            switcherIcon={<DownOutlined />}
                            showIcon={false}
                            selectable={false}
                            treeData={
                                disableAttr
                                    ? treeData.filter(
                                        (item: any) =>
                                            item.name !== "Реклама" && item.name !== "Регистрации"
                                    )
                                    : treeData
                            }
                            onExpand={onExpand}
                            expandedKeys={expandedKeys}
                            autoExpandParent={autoExpandParent}
                        />
                    }
                    title={
                        <Input
                            onChange={(e) => onSearch(e)}
                            placeholder="Найти условие"
                            allowClear
                        />
                    }
                    trigger="click"
                    placement="bottom"
                    overlayClassName="filter-popover"
                    open={isPopoverVisible}
                    onOpenChange={(visible)=>{setIsPopoverVisible(visible);}}
                >
                    <Button size={"small"} icon={<PlusOutlined />} type="primary" shape="circle" />
                </Popover>
                {!notParams && <RequestButton
                    btnDisabled={btnDisabled}
                    setBtnDisabled={setBtnDisabled}
                />}
            </div>
        </div>
    )
}

export default UniversalFilter
